import { usePromotePageData, usePromotePageState } from 'src/app/pages/promote/pageContext';
import type { PaymentType } from 'src/app/shared/utils/payments';
import { paymentMethod as getPaymentMethod } from 'src/app/shared/utils/payments';

import { useTracking } from '../useTracking';
import { useWaitForModalResult } from '../useWaitForModalResult';

export function useConfirmPaymentMethodOverwrite(): (paymentType: PaymentType) => Promise<boolean> {
	const {
		data: {
			user: { savedPaymentMethods, hasSubscription },
		},
	} = usePromotePageData();

	const [
		{
			paymentMethodSaveOptions: { shouldSavePaymentMethod },
			savedPaymentExperimentVariant,
			usingSavedPaymentMethod,
		},
	] = usePromotePageState();

	const { trackSavedPaymentAuthModalShown } = useTracking();
	const waitForModalResult = useWaitForModalResult();

	return async function confirmPaymentMethodOverwrite(paymentType: PaymentType): Promise<boolean> {
		if (
			(savedPaymentExperimentVariant === 'variant_1' || savedPaymentExperimentVariant === 'variant_2') &&
			usingSavedPaymentMethod
		) {
			return true;
		}
		const currentPaymentTypeGateway = getPaymentMethod(paymentType).gateway;
		// OverwritePaymentMethodConfirmationModal modal is not supported for paypal because of overlay issues
		if (!shouldSavePaymentMethod || !hasSubscription || !savedPaymentMethods || paymentType === 'paypal') return true;
		const isReplacingPaymentMethodOnGateway = savedPaymentMethods.some(
			({ gateway }) => gateway === currentPaymentTypeGateway,
		);
		if (isReplacingPaymentMethodOnGateway) {
			trackSavedPaymentAuthModalShown({ paymentType });
			return waitForModalResult('overwritePaymentMethod');
		}
		return true;
	};
}
